<template>
  
  <v-dialog v-model="dialog" persistent max-width="600px">
    <template v-slot:activator="{ on }">
      <v-btn rounded color="primary" style="margin: 10px" v-on="on">New Page</v-btn>
    </template>
    <v-card>
      <v-card-title>
        <span class="headline">New Page</span>
      </v-card-title>
      <v-card-text>
        <v-container>
          <v-row>
            <v-col cols="12" sm="12" md="12">
              <v-text-field label="Name" v-model="pageName" required></v-text-field>
            </v-col>
           </v-row>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" text @click="dialog = false">Close</v-btn>
        <v-btn color="blue darken-1" text @click="createPage">Save</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
  
</template>

<script>
  import axios from 'axios'
  export default {
    props: ['siteId'],
    data(){
      return {
        dialog : false,
        pageName: ""
      }
    },
    methods: {
      async createPage(){
        const request = {
          type : "management/page",
          action : "create",
          data: { siteId : this.siteId, pageName : this.pageName  }
        };
        try {
          const accessToken = await this.$auth.getAccessToken()
          const response = await axios.post('/', JSON.stringify(request),{ headers: {Authorization: `Bearer ${accessToken}`}})
          this.pages = response.data
          this.loading = false
        } catch (e) {
          this.$router.push("/login")
          console.error(e)
          this.loading = false  
        }
      }
    }
  }
</script>